import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";

const url = import.meta.env.PUBLIC_REMOTE_TRANSLATIONS_URL || 'http://localhost:3002';
const resources = {
  en: {
    glossary: {
      operations: 'operations'
    },
  },
};

i18n
  .use(ChainedBackend)

  // 3. wire react
  .use(initReactI18next)

  // 4. config
  .init({
    fallbackLng: 'dk',
    debug: false,
    defaultNS: 'common',
    partialBundledLanguages: true,
    interpolation: { escapeValue: false },
    react: {
      useSuspense: true,
    },
    backend: {
      backends: [HttpBackend, resourcesToBackend(resources)],
      backendOptions: [{
        loadPath: `${url}/locales/{{lng}}/{{ns}}.json`,
        crossDomain: true,
        allowMultiLoading: true,
        reloadInterval: 60 * 60 * 1000,
        requestOptions: {
          credentials: 'omit'
        }

      }, { resources }]
    },
  }
  );

export default i18n